import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'react-slidedown/lib/slidedown.css'
import Dropdown from '../../dropdown'
import { FormSelectYesNo } from '../formelements'
import config from '../../../config'

export function EnrolmentFormAuthorizations(props) {

  const [errors, setErrors] = useState({});

  const handleErrors = (nom, error) => {
    //console.log('error', nom, error)
    setErrors(error)
  }

  /* AUTORITZACIONS */
  const [authorizationsOpen, setAuthorizationsOpen] = useState(true);

  const toggleAuthorizationsOpen = () => {
    setAuthorizationsOpen(!authorizationsOpen);
  }

  /*
  const [authIntranet, setAuthIntranet ] = useState(false);
  const [authPublicacions, setAuthPublicacions ] = useState(false);
  const [authMaterial, setAuthMaterial ] = useState(false);
  const [authInternet, setAuthInternet ] = useState(false);
  */

  const [authDretsImatge , setAuthDretsImatge ] = useState("0");

  const [authCompromis, setAuthCompromis ] = useState("0");
  const [authGDPR, setAuthGDPR ] = useState("0");
  const [authSortides, setAuthSortides ] = useState("0");
  const [authAMPA, setAuthAMPA ] = useState("0");
  const [authMedica, setAuthMedica ] = useState("0");
  //const [authParacetamol, setAuthParacetamol ] = useState("0");
  const [authResponsable, setAuthResponsable ] = useState("0");
  //const [authMobils, setAuthMobils] = useState("0");
  const [authPortatils, setAuthPortatils ] = useState("");
  const [authRecursosDigitals, setAuthRecursosDigitals] = useState("0");
  const [authDocumentacioExtra, setAuthDocumentacioExtra] = useState("0");
  const [authAlumnatEstranger, setAuthAlumnatEstranger] = useState("");
  const [erasmusConcedit, setErasmusConcedit] = useState("0");
  const [authErasmus, setAuthErasmus] = useState("");
  const [authPractiquesEmpresa, setAuthPractiquesEmpresa] = useState("0");

  const [dadesAutoritzacions, setDadesAutoritzacions] = useState({validat: false});

  const handleDadesAutoritzacions = (noError) => {
    let d = {
     "validat": noError,
  
    /* DADES AUTORITZACIONS */
    /*
    "authIntranet": authIntranet,
    "authPublicacions": authPublicacions,
    "authMaterial": authMaterial,
    "authInternet": authInternet,
    //"authParacetamol": authParacetamol,
    //"authMobils": authMobils,
    */
    "authCompromis": authCompromis,
    "authGDPR": authGDPR,
    "authDretsImatge": authDretsImatge,
    "authSortides": authSortides,
    "authAMPA": authAMPA,
    "authMedica": authMedica,
    "authResponsable": authResponsable,
    "authPortatils": authPortatils,
    "authRecursosDigitals": authRecursosDigitals,
    "authDocumentacioExtra": authDocumentacioExtra,
    "authAlumnatEstranger": authAlumnatEstranger,
    "authErasmus": authErasmus,
    "authPractiquesEmpresa": authPractiquesEmpresa,
    }
  
      console.log("DADES_AUTORITZACIONS",d)
      setDadesAutoritzacions(d)
      props.handleDadesAutoritzacions(d)
    }

    /*
  const validaAuthIntranet = () => {
    return authIntranet ? null : "Heu d'indicar una resposta"
  }

  const validaAuthPublicacions= () => {
    return authPublicacions ? null : "Heu d'indicar una resposta"
  }

  const validaAuthMaterial= () => {
    return authMaterial ? null : "Heu d'indicar una resposta"
  }

  const validaAuthInternet= () => {
    return authInternet ? null : "Heu d'indicar una resposta"
  }
    */

  const validaAuthDretsImatge = () => {
    return authDretsImatge ? null : "Heu d'indicar una resposta"
  }


  const validaAuthSortides = () => {
    return authSortides === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthCompromis = () => {
    return authCompromis === "1" ? null : "Aquest camp és obligatori"
  }

  /*
  const validaAuthMobils = () => {
    return authMobils === "1" ? null : "Aquest camp és obligatori"
  }
  */

  const validaAuthPortatils = () => {
    return authPortatils !== "" ? null : "Aquest camp és obligatori"
  }

  const validaAuthDocumentacioExtra = () => {
    return authDocumentacioExtra === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthAlumnatEstranger= () => {
    return authAlumnatEstranger !== "" ? null : "Heu de triar una de les opcions"
  }

  const validaAuthErasmus= () => {
    return authErasmus !== "" ? null : "Heu de triar una de les opcions"
  }

  const validaAuthPractiquesEmpresa= () => {
    return authPractiquesEmpresa === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthGDPR= () => {
    return authGDPR === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthResponsable= () => {
    return authResponsable === "1" ? null : "Aquest camp és obligatori"
  }

 const handleAuthDretsImatge = (t) => {

      setAuthDretsImatge( t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }


 const handleChangeCompromis = (t) => {

      setAuthCompromis(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }

 const handleChangeGDPR = (t) => {

      setAuthGDPR(t === "0" ? "1" : "0") 

      //if(t === "1") handleDadesAutoritzacions(false)
      handleDadesAutoritzacions(false)
 }

 const handleChangeResponsable = (t) => {

      setAuthResponsable(t === "0" ? "1" : "0") 

      //if(t === "1") handleDadesAutoritzacions(false)
      handleDadesAutoritzacions(false)
 }

 /*
 const handleChangeMobils = (t) => {

      setAuthMobils(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }
*/

 const handleChangePortatils = (t) => {

      setAuthPortatils(t)

      handleDadesAutoritzacions(false)
 }

 const handleChangeSortides = (t) => {

      setAuthSortides(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }

 const handleChangeAMPA= (t) => {

      setAuthAMPA(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }

 const handleChangeMedica= (t) => {

      setAuthMedica(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }

 /*
 const handleChangeParacetamol = (t) => {

      setAuthParacetamol(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }
  */

 const handleChangeRecursosDigitals = (t) => {

      setAuthRecursosDigitals(t === "0" ? "1" : "0") 

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeAlumnatEstranger = (t) => {

      setAuthAlumnatEstranger(t)

      handleDadesAutoritzacions(false)
 }


 const handleChangeDocumentacioExtra = (t) => {

      setAuthDocumentacioExtra(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }


 const handleChangeErasmusConcedit= (t) => {

      setErasmusConcedit(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }

 const handleChangeErasmus= (t) => {

      setAuthErasmus(t)

      handleDadesAutoritzacions(false)
 }

 const handleChangePractiquesEmpresa= (t) => {

      setAuthPractiquesEmpresa(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }



/* VALIDA AUTORITZACIONS */
const validaAutoritzacions = (e) => {
  if(e) e.preventDefault();

  let error = {}

  /* 
  error.authIntranet = validaAuthIntranet();
  handleErrors('authIntranet',error)
  
  error.authPublicacions = validaAuthPublicacions();
  handleErrors('authPublicacions',error)
  
  error.authMaterial = validaAuthMaterial();
  handleErrors('authMaterial',error)
  
  error.authInternet = validaAuthInternet();
  handleErrors('authInternet',error)
  */

  error.authCompromis = validaAuthCompromis();
  handleErrors('authCompromis',error)

  //error.authMobils = validaAuthMobils();
  //handleErrors('authMobils',error)

  if(props.dadesEstudis.curs.id.startsWith("ESOLOE") || props.dadesEstudis.curs.id.startsWith("BATXLOE"))
  {
    error.authPortatils = validaAuthPortatils();
    handleErrors('authPortatils',error)
  }

  if( props.dadesEstudis.nouAlumne && 
    (
      props.dadesEstudis.curs.id.startsWith("BATXLOE") ||
      props.dadesEstudis.cicle === "CFGM" ||
      props.dadesEstudis.cicle === "CFGS" 
    )
  )
  {
    error.authDocumentacioExtra = validaAuthDocumentacioExtra();
    handleErrors('authDocumentacioExtra',error)

    error.authAlumnatEstranger = validaAuthAlumnatEstranger();
    handleErrors('authAlumnatEstranger',error)
  }


  if(
      props.dadesEstudis.cicle === "CFGM" ||
      props.dadesEstudis.cicle === "CFGS" 
  )
  {

    if (erasmusConcedit) {
      error.authErasmus = validaAuthErasmus();
      handleErrors('authErasmus', error)
    }

  error.authPractiquesEmpresa = validaAuthPractiquesEmpresa();
  handleErrors('authPractiquesEmpresa',error)
  }

  error.authGDPR = validaAuthGDPR();
  handleErrors('authGDPR',error)

  error.authResponsable = validaAuthResponsable();
  handleErrors('authResponsable',error)

  error.authDretsImatge = validaAuthDretsImatge();
  handleErrors('authDretsImatge',error)


  if( props.dadesPersonals.edat >= 18 ) {

    error.authSortides = validaAuthSortides();
    handleErrors('authSortides',error)

  }


  setErrors(error)

  let noError = true;
  //DEVELOP 
  if(!config.develop) // bypass errors if develop == true
  {
    Object.keys(error).map( (k) => { if(error[k] !== null) noError = false } )
  }

  //console.log('ERROR',error);

  handleDadesAutoritzacions(noError)

  if(noError)
  {
     setAuthorizationsOpen(false);
  }

  return noError;
}

  return (
    <div className="container authorizations">
      <div className="row">
        <div className="col col-12 ">
          <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">
            <div className="t-Region-header">
              <div className="t-Region-headerItems  t-Region-headerItems--controls">
                <button
                  className="t-Button t-Button--icon t-Button--hideShow"
                  type="button"
                  onClick={toggleAuthorizationsOpen}
                >
                  {authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronUp}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                  {!authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                </button>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--title">
                <h2 className="t-Region-title a-Collapsible-heading">
                  Protecció de dades
                </h2>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
            </div>
            <div className="t-Region-bodyWrap">
              <Dropdown open={authorizationsOpen}>
                <div className="t-Region-body a-Collapsible-content">
                  <div className="container">
                    <div className="row">
                      <div className="col col-12 ">
                        <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                          <div className="t-Region-bodyWrap">
                            <div className="t-Region-body">
                              <div className="container">

                                   { props.dadesPersonals.edat >= 16 ? (
                                     <>
                                <div className="row">
                                  <div className="col col-12 ">

                                    <h4>
{/*                                    Carta de compromís educatiu: Alumnat menors 16 anys complerts. Curs {props.enguany}-{props.anyVinent} */}
                                    Carta de compromís educatiu. Curs {props.enguany}-{props.anyVinent} 
                                    </h4>

                                          <p>La carta de compromís educatiu és un document que té com a finalitat potenciar la comunicació, la participació, la implicació, el compromís i la 
                                            coresponsabilitat entre els centres i les famílies en l'educació d'infants i joves.  Aquesta carta té per objectius principals, entre d'altres:</p>

                                          <ol>
                                            <li>Compartir amb les famílies els principis i els continguts del projecte educatiu del centre i, si escau, els projectes educatius de l'entorn.</li>
                                            <li>Millorar la informació i la comunicació entre el centre i les famílies.</li>
                                            <li>Facilitar a les famílies l'exercici dels seus drets i el compliment dels deures.</li>
                                            <li>Fomentar la convivència i el bon clima escolar.</li>
                                            <li>Coresponsabilitzar el centre i la família en l'èxit acadèmic, personal i social de l'alumnat i també en el compromís cívic dels infants i joves.</li>
                                          </ol>

                                          <p>El centre, les famílies i l'alumnat signem aquest document i ens comprometem amb les mesures i recomanacions aquí subscrites per millorar 
                                            així el clima escolar, la comunicació i els resultats acadèmics de l'alumnat.</p>

                                    <h5>
                                    Per part del centre:
                                    </h5>

                                      <ol>
                                        <li>Facilitar una bona relació amb l'alumnat establint canals de comunicació per facilitar el seguiment de la progressió acadèmica, professional i personal de l'alumnat. S'informa tres cops al curs de l'avaluació i evolució de l'alumnat.</li>
                                        <li>Instar a l'alumnat a respectar les normes de funcionament de l'escola, en particular, les que afecten la convivència escolar, el desenvolupament normal de les classes i les activitats complementàries.</li>
                                        <li>Informar la família dels resultats de les avaluacions i de l'evolució acadèmica i personal de l'alumnat.</li>
                                        <li>Oferir uns continguts i una metodologia d'ensenyament que procuri estimular el progrés de l'alumnat vers l'obtenció dels millors resultats acadèmics i l'adquisició de destreses i habilitats per aconseguir l'excel·lència en el nostre ofici, d'acord amb les seves capacitats, mitjançant el treball personalitzat i l'avaluació continuada.</li>
                                        <li>Facilitar unes pràctiques de qualitat a l'alumnat per tal d'aconseguir completar de manera correcta la seva formació en l'ofici escollit, arribar a ser un professional d'èxit i aportar valor afegit al sector.</li>
                                      </ol>


                                    <h5>
                                    Per part de la família:
                                    </h5>

                                          <ol>
                                            <li>Contribuir a crear un vincle de confiança mútua amb els professionals de l'escola per a treballar conjuntament en la construcció del futur del nostre fill o filla.</li>
                                            <li>Instar el fill o la filla a respectar les normes de funcionament de l'escola, en particular, les que afecten la normativa del cicle formatiu, uniformitat, sanitat,...</li>
                                            <li>Atendre les peticions d'entrevistes i/o de comunicacions que formuli l'escola.</li>
                                            <li>Compartir amb l'escola tota la informació que sigui rellevant pel procés d'aprenentatge i progrés personal del nostre fill o filla.</li>
                                            <li>Col·laborar amb l'escola en el procés de millora contínua, amb suggeriments i reflexions de tot allò que pugui ser susceptible de ser millorat, a través dels canals establerts (entrevistes, web, correu electrònic...)</li>
                                          </ol>

                                    <h5>
                                    Per part de l'alumnat:
                                    </h5>

                                          <ol>
                                            <li>Assistir a classe, participar en les activitats formatives previstes a la programació general del centre i respectar els horaris establerts.</li>
                                            <li>Respectar les Normes bàsiques de convivència, en particular aquelles que afecten el desenvolupament normal de les classes i activitats professionalitzadores prestant especial esment a: atenció, esforç, col·laboració, educació, higiene personal, uniformitat, respecte a les persones i als mitjans disponibles, limitació de l'ús de telèfons mòbils i xarxes socials durant la jornada escolar.</li>
                                            <li>Quan l'alumnat desenvolupi el rol de client, s'ha de comportar amb respecte i educació amb els companys que fan les pràctiques, respectant horaris i temps del servei. També ha de mostrar una bona predisposició a tastar i menjar nous plats i productes que no li són afins, per tal de completar la seva formació.</li>
                                            <li>Realitzar les tasques encomanades pel professorat en l'exercici de les seves funcions docents.</li>
                                          </ol>

                                    <p>
                                      <input type="checkbox" id="authCompromis" name="authCompromis" value={authCompromis} checked={authCompromis === "1" ? true : false } onChange={ (t) => { handleChangeCompromis(t.target.value) } } required/>
                                        <label htmlFor="authCompromis">Perquè així consti, signem aquesta carta de compromís educatiu.</label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authCompromis}</span>
                                    </p>


                                  </div>
                                </div>

                                        </>
                                   ) : (
                                     <>

                                <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                    {/* Carta de compromís educatiu: Alumnat menors 16 anys complerts. Curs {props.enguany}-{props.anyVinent} */}
                                    Carta de compromís educatiu. Curs {props.enguany}-{props.anyVinent} 
                                    </h4>

                                          <p>Són conscients que l'educació de l'alumnat implica l'acció conjunta de la família, de l’alumnat i del centre educatiu i per aquest motiu signem aquest document, el qual comporta els següents compromisos:</p>

                                    <h5>
                                    Per part del centre:
                                    </h5>

                                      <ol>
																			<li>Facilitar una formació que contribueixi al desenvolupament integral de la personalitat de l'alumnat.</li>
																			<li>Vetllar per fer efectius els drets de l'alumnat en l'àmbit escolar.</li>
																			<li>Informar de les normes d'organització i funcionament del centre (NOFC) i del Projecte educatiu de centre (PEC).</li>
																			<li>Informar dels criteris que s’aplicaran per avaluar el rendiment acadèmic, fer- ne una valoració objectiva de l'evolució acadèmica i personal i, si escau, explicar els resultats de les avaluacions.</li>
																			<li>Mantenir comunicació regular per informar de l’evolució acadèmica i personal.</li>
																			<li>Comunicar les inassistències al centre i qualsevol altre circumstància que sigui rellevant per al seu desenvolupament acadèmic i personal.</li>
																			<li>Avisar la família, mitjançant les dades facilitades al centre, quan l'alumnat es trobi indisposat o hagi comès una falta lleu o greu.</li>
																			<li>Atendre, en un termini raonable, les peticions d’entrevista o de comunicació.</li>
																			<li>Revisar conjuntament el compliment d'aquests compromisos quan s'escaigui.</li>
                                      </ol>


                                    <h5>
                                    Per part de la família:
                                    </h5>

                                          <ol>
																			<li>Respectar el caràcter propi del centre i reconèixer l'autoritat del professorati, més específicament, la del equip directiu.</li>
																			<li>Compartir amb el centre l'educació de l’alumnat i afavorir les complicitats que són necessàries per aplicar el projecte educatiu de centre.</li>
																			<li>Respectar les normes d'organització i funcionament de centre (NOFC) i, en particular les que afectin a la convivència escolar i el desenvolupament normal de les classes.</li>
																			<li>Facilitar al centre les informacions del/de la fill/a que siguin rellevants per al procés d’aprenentatge.</li>
																			<li>Ajudar el/la vostre/a fill/a a organitzar el temps d’estudi a casa i a preparar el material per a l’activitat escolar. Garantir el portar l’agenda cada dia a l’Institut i fer-la servir amb ús exclusiu pel centre.</li>
																			<li>Adoptar criteris i mesures que puguin afavorir el rendiment escolar del/de la fill/a.</li>
																			<li>Atendre en un termini raonable les peticions d’entrevista o de comunicació que formuli el centre.</li>
																			<li>Adreçar-se directament al centre per contrastar les discrepàncies, coincidències o suggeriments en relació amb l’aplicació del projecte educatiu en la formació del/de la fill/a.</li>
																			<li>Vetllar perquè l’alumnat compleixi el deure bàsic de l’estudi i d’assistència regular i puntual a les activitats acadèmiques, i també perquè faci les tasques encomanades a classe i a casa pel professorat.</li>
																			<li>Revisar conjuntament amb el centre educatiu el compliment dels compromisos d’aquesta carta i, si escau, el contingut.</li>
																			<li>S’autoritza en tots el casos sense excepció, que puguem parlar amb els/les fills/es sobre els temes de l’Institut que afectin a ell/a o als/a les companys/es. En aquestes reunions es respectarà sempre l’intimitat i s’aixecarà acta</li>
                                          </ol>


                                    <p>En cas que l’estudiant cometi una falta greu, en especial faltes de respecte verbals o físiques al professorat o els companys del centre, es trucarà immediatament a les famílies perquè vinguin a buscar-lo, quedant exclòs de l’aula en espera de les accions que preveu la <b>Normativa d’organització i funcionament del centre</b></p>

                                    <p>
                                      <input type="checkbox" id="authCompromis" name="authCompromis" value={authCompromis} checked={authCompromis === "1" ? true : false } onChange={ (t) => { handleChangeCompromis(t.target.value) } } required/>
                                        <label htmlFor="authCompromis">Perquè així consti, signem aquesta carta de compromís educatiu.</label>
                                      <span id="auhtCompromis_ERROR" className="a-Form-error">{errors.authCompromis}</span>
                                    </p>

                                  </div>
                                </div>

                                        </>
                                    )
                                  }

<br/>

                                {/* AUTORITZACIONS ESPECIFIQUES MOBIL ESO 
                                { ( props.dadesEstudis.curs.id.startsWith("ESOLOE") ) ? (<>
                              <div className="row">
                              <div className="col col-12 ">
                                <h4>
                                  Ús del mòbil en el centre educatiu
                                </h4>
                                <p>

                                  Des de fa molts anys el nostre centre és un centre on no es poden utilitzar els
                                  dispositius mòbils. Tot i així, tenim petits problemes de disciplina ja que hi ha alumnat
                                  que l’utilitza en intercanvis de classes o en altres moment. Aquest fet pot comportar la
                                  vulneració del dret d’imatge i intimitat d’altres alumnes, si es fan fotos, vídeos...<br/>

                                  <br/>

                                  Per tant, després de diferents reflexions al voltant d’aquests aspectes i altres, l’Equip
                                  Directiu amb el recolzament de l’inspector i l’aprovació del Consell Escolar ha decidit
                                  millorar el protocol d’ús dels mòbils pel curs 24/25 amb els següents punts:<br/>


                                  <ol>
                                        <li>A primera hora del matí, el professor/a que estigui a cada grup ha de recollir els mòbils apagats de l’alumnat i els ha de ficar en la caixa especial per guardar-los.</li>
                                        <li>El professor/a que recull els mòbils anota l’alumnat que deixa el seu mòbil.</li>
                                        <li>La caixa on es depositen els mòbils estarà en un espai tancat en clau.</li>
                                        <li>Si es veu algun mòbil en el centre, encara que l’alumne o alumna no estigui fent ús, es confiscarà durant tot el dia i la família haurà de venir a per ell.</li>
                                        <li>Qualsevol membre de la comunitat educativa pot requisar el mòbil i portar-lo a consergeria perquè la família el vingui a buscar al final de la jornada.</li>
                                        <li>Si l’alumnat necessita fer una trucada o la família necessita contactar amb els seus fills/es està a la seva disposició el telèfon del centre (937851143)</li>
                                        <li>El centre no es responsabilitza dels mòbils. Tot mòbil que entra al centre estarà exempt de qualsevol responsabilitat (trencament, ratllades, pèrdues, robatoris... )</li>

                                  </ol>


                                  <input type="checkbox" id="authMobils" name="authMobils" value={authMobils} checked={authMobils === "1" ? true : false } onChange={ (t) => { handleChangeMobils(t.target.value) } } required/>
                                  <label htmlFor="authMobils"> He llegit i accepto el protocol</label>
                                  <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authMobils}</span>
                                </p>


                              </div>
                            </div>

                                  </>
                                ) : ( 
                                  <>
                              <div className="row">
                              <div className="col col-12 ">
                                <h4>
                                  Ús del mòbil en el centre educatiu
                                </h4>
                                <p>
                                  D'acord amb el Pla de Convivència del Centre us volem informar sobre la
                                  NORMATIVA QUE REGULA L'ÚS DE TELÈFONS MÒBILS I APARELLS
                                  ELECTRÒNICS A L'INSTITUT. (basada en la Llei 12/2009, del 10 de juliol, d'Educació)  <br/>

                                  <ol>

                                  <li>L'ús del mòbil i aparells de reproducció de música està prohibit en horari de classe, dins l'aula teòrica i pràctica. 
                                    L'alumnat de PFI-PTT no els podrà utilitzar tampoc en tot el centre. Per tal de respectar i garantir el dret d'imatge està totalment prohibit fer fotos i/o vídeos dins
                                     el recinte escolar. Aquests aparells, només es podran utilitzar amb usos pedagògics quan el professor/a ho indiqui.  </li>

                                  <li>A l'aula, el telèfon mòbil haurà d'estar en silenci i guardat.</li>
                                  <li>Està totalment prohibit carregar els mòbils al centre.</li>
                                  <li>Si un/a professor/a detecta un alumne/a fent un ús incorrecte del mòbil durant la classe, pot demanar a l'alumne/a que apagui el dispositiu i el deixi a sobre de la taula del professor fins al final de la classe.</li>
                                  <li>En el cas que un/a alumne/a reincideixi es considerarà com una falta lleu i s'aplicarà el Reglament de Règim Intern del centre. 
                                    L'alumnat de PTT-PFI que usi el mòbil en hores de classe de manera reincident, un cop ha estat ja avisat marxarà cap a casa amb un comunicat d'incidència.</li>
                                  <li>EL CENTRE NO ES FA RESPONSABLE del desperfecte, de la pèrdua o sostracció dels aparells que, sota la responsabilitat de cada alumne/a, es portin a l'institut.</li>
                                  </ol>


                                  <input type="checkbox" id="authMobils" name="authMobils" value={authMobils} checked={authMobils === "1" ? true : false } onChange={ (t) => { handleChangeMobils(t.target.value) } } required/>
                                  <label htmlFor="authMobils"> He llegit i accepto la normativa del centre que regula l'ús del mòbil i altres aparells electrònics</label>
                                  <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authMobils}</span>
                                </p>


                              </div>
                            </div>
                            </>)}

                                <br/>
*/}

                                {/* AUTORITZACIONS ESPECIFIQUES ESO i BATX */}
                                { ( props.dadesEstudis.curs.id.startsWith("ESOLOE") || props.dadesEstudis.curs.id.startsWith("BATXLOE")) && (<></>
                                )}

                                {/* AUTORITZACIONS ESPECIFIQUES ESO */}
                                { props.dadesEstudis.curs.id.startsWith("ESOLOE") && (<>
                              <div className="row">
                              <div className="col col-12 ">
                                <h4>
                                Acord Cessió Ordinador Departament Educació - Famílies
                                </h4>
                                <p>

                                  Des del centre posem a la teva disposició un ordinador per tal que en facis el bon ús necessari per al teu recorregut acadèmic. És la teva responsabilitat assegurar-te que es manté en bon estat al llarg de tot el curs i durant tota l’etapa educativa. El centre et pot demanar al llarg del curs diversos punts de control si així ho considera. Recorda, l’ordinador no és propietat teva, sinó que el centre te’l deixa en préstec i, en últim terme, el propietari legal és la Generalitat de Catalunya (qui pot decidir fiscalitzar-ne l’ús si ho creu convenient).  <br/> <br/>

                                  A través d’aquest document s’estableixen les següents condicions d’obtenció d’equipament informàtic del centre:<br/>

                                  <ul>
																			<li>Rebre un dispositiu Lenovo propietat de Generalitat de Catalunya fins que aquest em sigui reclamat pel centre o, en cas de no ser-ho, fins a final de l’etapa corresponent o en cas de marxar del centre.</li>
																			<li>El dispositiu pot ser requerit en qualsevol moment per l’institut per motius de manteniment.</li>
																			<li>El dispositiu és entregat juntament amb un <b>carregador</b>, que s’ha de conservar.</li>
																			<li><b>Mantenir</b> tot el material en el <b>mateix estat</b> amb el qual s’ha entregat.</li>
																			<li>En cas de deteriorament o mal funcionament, informar immediatament i portar l’ordinador al centre per valorar la reparació. <b>En cap cas portar a reparar l’ordinador</b>, o intentar fer-li una reparació.</li>
																			<li>En cas de <b>pèrdua o avaria del carregador</b>, comprar-ne un de la mateixa marca i model que el que venia amb l’ordinador.</li>
																			<li>Retornar quan em sigui requerit o bé al <b>final de l’etapa</b> que correspongui el contingut complet de l’equipament: el dispositiu i el carregador en bones condicions.</li>
                                  </ul>

                                  <label>
                                    <input type="radio" id="authPortatils" name="authPortatils" value={authPortatils} checked={authPortatils === "1" ? true : false} onChange={(t) => { handleChangePortatils("1") }} required /> 
                                    Accepto i em comprometo a seguir els acords establerts anteriorment, assumint totes les responsabilitats que se’n deriven.
                                    </label>

                                  <br />

                                  <label> 
                                    <input type="radio" id="authPortatils" name="authPortatils" value={authPortatils} checked={authPortatils === "0" ? true : false} onChange={(t) => { handleChangePortatils("0") }} required />
                                     No accepto i rebutjo l’ordinador.
                                  </label>

                                  <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authPortatils}</span>

                                </p>


                              </div>
                            </div>

                                  <br/>


                              <div className="row">
                              <div className="col col-12 ">
                                <h4>
                                  Autorització per a l’ús de serveis i recursos digitals a Internet per treballar a l'aula
                                </h4>
                                <p>

                                    Per al treball acadèmic de les diferents matèries els alumnes han d'utilitzar diverses eines informàtiques i, en especial, aquelles relacionades amb la transmissió d’informació a traves d'Internet: correu electrònic, creació de blogs opàgines web, etc.<br/>
                                  <br/>

                                    Per tal de treballar aquests continguts el centre crearà un compte personal de Google Apps per cada membre de l'alumnat.<br/>
                                  <br/>

                                    El compte tindrà el format usuari@insjaumemimo.cat i permetrà fer diferents tasques relacionades amb el currículum. Aquest compte serà d'us exclusivament acadèmic, de manera que l'alumnat no haurien d'utilitzar-lo dins del seu àmbit personal.<br/>
                                  <br/>

                                    En algun cas també poden tenir accés a cursos d'alguna matèria en la plataforma Moodle del centre. D'altra banda, si en alguna matèria s’utilitzés llibres digitals, caldria que la corresponent editorial creessin els comptes a instància del centre.<br/>
                                  <br/>
                                    La normativa del Departament d'Educació marca que per als menors de 14 anys es necessari el permís per escrit dels pares o tutors, mentre que si l'alumne es major de 14 anys, només cal informar els pares o tutors<br/>
                                  <br/>

                                  <input type="checkbox" id="authRecursosDigitals" name="authRecursosDigitals" value={authRecursosDigitals} checked={authRecursosDigitals === "1" ? true : false } onChange={ (t) => { handleChangeRecursosDigitals(t.target.value) } } required/>
                                  <label htmlFor="authRecursosDigitals"> 

                                   { props.dadesPersonals.edat < 14 ? 
                                      "Autoritzo que el centre gestioni la creació de l’usuari i contrasenya associats als següents recursos i serveis d’Internet:"
                                      :
                                      "Declaro que estic assabentat/ada que el centre gestionarà la creació de l’usuari i contrasenya associats als següents cursos i serveis d’Internet:"
                                   }

                                       <br/> Google Apps per a Educació, plataforma Moodle i si s’escau, llibres de text digitals per al treball acadèmic amb finalitat pedagògiques. <br/>

                                  </label>
                                  <span id="auhtRecursosDigitals_ERROR" className="a-Form-error">{errors.authRecursosDigitals}</span>
                                </p>

                                <p>
                                La gestió d'aquests identificadors i la responsabilitat de l’ús que se'n faci en l'àmbit escolar correspon al
                                centre educatiu. Aquest no es fa responsable de l’ús indegut del recurs i dels seus continguts per part dels
                                usuaris. L'usuari serà únic responsable de les infraccions en què pugui incórrer o dels perjudicis que pugui
                                causar per un us inadequat dels seus serveis o dels seus continguts.
                                </p>

                              </div>
                            </div>


                                <br/>

                                  </>
                                )}



                                <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                       Drets d'imatge
                                    </h4>

                                      <p>
                                      L’Institut Jaume Mimó disposa de diversos espais web i d’entorns de treball on informa i fa difusió
                                      de les seves activitats lectives, complementàries i extraescolars.
                                      Als web s’hi poden publicar imatges en les quals apareixen, individualment o en grup, alumnes
                                      realitzant les activitats esmentades.<br/>
                                      <br/>
                                      Donat que el dret a la pròpia imatge està reconegut a l’Article 18.1 de la Constitució espanyola iregulat
                                      per la Llei orgànica 1/1982, del 5 de maig, sobre el dret a l’honor, a la intimitat personal i familiar i a la
                                      pròpia imatge, la Direcció d’aquest centre demana el consentiment a les famílies (en cas de menors
                                      d’edat) o a l’alumnat major d’edat per publicar fotograﬁes on hi aparegui i sigui clarament
                                      identiﬁcables.<br/>
                                      <br/>
                                      Així mateix, els informem que el centre disposa de càmeres de videovigilància per tal de vetllar per
                                      la seguretat de tota la comunitat educativa. L’enregistrament de les imatges són susceptibles de
                                      consulta per part de la Direcció en casos d’incompliment amb la normativa. Aquestes imatges es
                                      conservaran un termini màxim d’un mes i no es faran públiques en cap moment.<br/>
                                      <br/>

                                      <input type="checkbox" 
                                      id="authDretsImatge" 
                                      name="authDretsImatge" 
                                      value={authDretsImatge} 
                                      checked={authDretsImatge === "1" ? true : false } 
                                      onChange={ (t) => { handleAuthDretsImatge(t.target.value) } 
                                      }/>

                                      <label htmlFor="authDretsImatge">
                                      AUTORITZO 
                                      { props.dadesPersonals.edat < 18 ? 
                                      (<> que la imatge i/o veu de l'alumnat matriculat </> ) : (<> que la meva imatge i/o veu </>) }
                                      pugui aparèixer en fotografies i vídeos corresponents a 
                                      les activitats lectives, complementàries, extraescolars i de promoció i difusó organitzades per l'institut i publicades a pàgines WEB,
                                      xares socials, filmacions no comercials o revistes i publicacions d'àmbit educatiu.
                                          </label>
                                      <span id="auhtDretsImatge_ERROR" className="a-Form-error">{errors.authDretsImatge}</span>
                                      </p>
                                </div>
                               </div>

                                      <br/>

                                <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                      Informació bàsica sobre protecció de dades
                                    </h4>
                                    <p>
                                      <b>Responsable del tractament:</b> Direcció del centre educatiu.<br/>
                                      <b>Finalitat:</b> Autorització difusió d'imatge/veu i material elaborat als espais de comunicació i difusió del centre.<br/>
                                      <b>Legitimació:</b> Consentiment de l'interessat o de la persona que ostenta la tutoria legal en cas de menors d'edat.<br/>
                                      <b>Destinataris:</b> Les dades no es comunicaran a tercers, excepte en els casos previstos per llei, o si ho heu consentit
                                      prèviament.<br />
                                      <b>Drets:</b> Accedir a les dades, rectificar-les, suprimir-les, oposar-se al tractament i sol·licitar-ne la limitació.<br />
                                      <b>Informació addicional:</b> Podeu consultar la informació addicional i detallada sobre protecció de dades a la pàgina:
                                    </p>
                                      <ul>
                                        <li><a href="https://educacio.gencat.cat/ca/Detall/alumnes-centres-departament" target="_blank" rel="noreferrer">https://educacio.gencat.cat/ca/Detall/alumnes-centres-departament</a> </li>
                                        <li><a href="https://educacio.gencat.cat/ca/Detall/personal-centres-departament" target="_blank" rel="noreferrer">https://educacio.gencat.cat/ca/Detall/personal-centres-departament</a></li>
                                      </ul>
                                    <br/>



                                    <p>
                                      <input type="checkbox" id="authGDPR" name="authGDPR" value={authGDPR} checked={authGDPR === "1" ? true : false } onChange={ (t) => { handleChangeGDPR(t.target.value) } } required/>
                                      <label htmlFor="authGDPR">He llegit la informació bàsica sobre protecció de dades i autoritzo el tractament de les meves dades personals.</label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authGDPR}</span>
                                    </p>

                                  </div>
                                </div>

                                      <br/>

                                { props.dadesPersonals.edat < 18 ? (
                                  <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                    Autorització per a realitzar activitats fora del centre
                                    </h4>
                                    <p>
                                      <input type="checkbox" id="authSortides" name="authSortides" value={authSortides} checked={authSortides === "1" ? true : false } onChange={ (t) => { handleChangeSortides(t.target.value) } } required/>
                                      <label htmlFor="authSortides">
                                        AUTORITZO a l'alumnat matriculat a:
                                        <ul>

                                          <li>l'alumne realitzi les sortides programades durant el curs escolar.</li>
                                          { props.dadesEstudis.curs.id.startsWith("BATXLOE")  && (
                                            <>
                                              <li>si escau, l'alumne es quedi en el destí de la sortida o punts intermitjos (per exemple estacions de tren entre el destí i l’origen) durant el curs escolar quedant el centre exonerat de la responsabilitat de guàrdia i custòdia.</li>
                                              <li>si escau, l'alumne vagi directament al destí de la sortida o lloc de sortida diferent del centre (per exemple estació de tren) durant el curs escolar.</li>
                                              <li>l'alumne pugui sortir del centre durant el temps d'esbarjo quedant el centre exonerat de la responsabilitat de guàrdia i custòdia.</li>
                                              <li>l'horari de l'alumne sigui modificat si hi ha alteracions i pugui sortir abans o entrar més tard quedant el centre exonerat de la responsabilitat de guàrdia i custòdia</li>
                                            </>
                                          ) }
                                        </ul>

                                          </label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authSortides}</span>
                                    </p>

                                  </div>
                                </div>) : (
                                  <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                    Responsabilització sortides
                                    </h4>
                                    <p>
                                      <input type="checkbox" id="authSortides" name="authSortides" value={authSortides} checked={authSortides === "1" ? true : false } onChange={ (t) => { handleChangeSortides(t.target.value) } } required/>
                                      <label htmlFor="authSortides"> Em RESPONSABILITZO dels desplaçaments que faci pel meu compte cap/des de punts preestablerts en activitats i sortides del centre.  </label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authSortides}</span>
                                    </p>

                                  <br/>

                                  </div>
                                </div>)
                                }


                                { props.dadesPersonals.edat < 18 ?(
                                  <>
                                  <br/>
                                  <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                    Autorització mèdica
                                    </h4>
                                    <p>
                                      <input type="checkbox" id="authMedica" name="authMedica" value={authMedica} checked={authMedica === "1" ? true : false } onChange={ (t) => { handleChangeMedica(t.target.value) } } required/>
                                      <label htmlFor="authMedica"> AUTORITZO en cas que es produís una urgència mèdica imprevista greu i l'Institut l'hagués d'acompanyar a un centre mèdic, mentre no arriba la família, autoritzo el professor acompanyant a prendre totes les decisions oportunes (proves, anàlisis, transfusions ...). </label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authMedica}</span>
                                    </p>
                                  </div>
                                </div>

                                    <br />
                                  </>):
                                  (<>
                                  <br/>
                                  <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                    Autorització mèdica
                                    </h4>
                                    <p>
                                      <input type="checkbox" id="authMedica" name="authMedica" value={authMedica} checked={authMedica === "1" ? true : false } onChange={ (t) => { handleChangeMedica(t.target.value) } } required/>
                                      <label htmlFor="authMedica"> AUTORITZO a informar a la família en cas de necessitat mèdica
                                         </label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authMedica}</span>
                                    </p>
                                  </div>
                                </div>

                                    <br />
                                  </>)}

{/*
                                      <br/>

                                  <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                    Autorització per a l'administració de paracetamol
                                    </h4>
                                    <p>
                                      <input type="checkbox" id="authParacetamol" name="authParacetamol" value={authParacetamol} checked={authParacetamol === "1" ? true : false } onChange={ (t) => { handleChangeParacetamol(t.target.value) } } required/>
                                      <label htmlFor="authParacetamol"> AUTORITZO  El centre educatiu a administrar paracetamol al meu fill/a, en cas de presentar febre superior a 38℃ de temperatura corporal mentre s'espera l'arribada d'algun familiar que el pugui portar a casa. </label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authParacetamol}</span>
                                    </p>

                                  </div>
                                </div>

*/}


                                  <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                    Autorització cessió del correu electrònic a Alumni Mimó
                                    </h4>
                                    <p>
                                      <input type="checkbox" id="authAMPA" name="authAMPA" value={authAMPA} checked={authAMPA === "1" ? true : false } onChange={ (t) => { handleChangeAMPA(t.target.value) } } required/>
                                      <label htmlFor="authAMPA"> AUTORITZO que el centre faliciti el meu correu electrònic a Alumni Mimó per poder rebre informació </label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authAMPA}</span>
                                    </p>

                                  </div>
                                </div>

                              <br/>

                                {/* AUTORITZACIONS ESPECIFIQUES BATX i CICLES */}
                                { props.dadesEstudis.nouAlumne && 
                                  (
                                    props.dadesEstudis.curs.id.startsWith("BATXLOE") ||
                                    props.dadesEstudis.cicle === "CFGM" ||
                                    props.dadesEstudis.cicle === "CFGS" 
                                  ) &&
                                (<>
                              <div className="row">
                              <div className="col col-12 ">
                                <h4>
                                Documentació secretaria
                                </h4>
                                <p>

                              Tot l'alumnat de <b>Formació Professional i Batxillerat de nou ingrés</b> al centre ha de portar a secretaria entre l'1 i el 19 de setembre

                                  <ul>
																			<li>l'original del DNI.</li>
																			<li>el resguard del títol pel qual s'accedeix als estudis matriculats.</li>
                                  </ul>

                                  En cas de no aportar aquesta documentació, l'estudiant pot ser donat de baixa.

                                  <br />
                                  <br />

                                  <label> 
                                      <input type="checkbox" id="authDocumentacioExtra" name="authDocumentacioExtra" value={authDocumentacioExtra} checked={authDocumentacioExtra === "1" ? true : false } onChange={ (t) => { handleChangeDocumentacioExtra(t.target.value) } } required/>
                                    Em comprometo a aportar aquesta documentació en el període estipulat
                                  </label>

                                  <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authDocumentacioExtra}</span>

                                </p>


                              </div>
                            </div>

                                  <br/>

                                </>)}



                                {/* AUTORITZACIONS ESPECIFIQUES CICLES */}
                                { 
                                  (
                                    props.dadesEstudis.cicle === "CFGM" ||
                                    props.dadesEstudis.cicle === "CFGS" 
                                  ) &&
                                (<>

                              <div className="row">
                              <div className="col col-12 ">
                                <h4>
                                Alumnat provinents d'estudis estrangers
                                </h4>
                                <p>

                                    En cas de ser un alumnat provinent d'estudis estrangers al batxillerat o FP, cal que l'alumne/a presenti la credencial d'homologació del títol corresponent, i el volant de matrícula condicional que indica que ha iniciat el tràmit de l'expedient d'homologació. En cas que no acrediti la convalidació o homologació abans de final de curs no es podrà avaluar l'alumne/a, i no passarà de curs

                                  <br />
                                  <br />


                                  <label htmlFor="authAlumnatEstranger1">
                                    <input type="radio" id="authAlumnatEstranger1" name="authAlumnatEstranger" value={authAlumnatEstranger} checked={authAlumnatEstranger === "1" ? true : false} onChange={(t) => { handleChangeAlumnatEstranger("1") }} required /> 
                                      Estic assabentat que si no acredito abans de final de curs aquesta documentació, no podré ser avaluat/da i no podré passar de curs.
                                    </label>

                                  <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authAlumnatEstranger}</span>

                                  <br />

                                  <label htmlFor="authAlumnatEstranger0"> 
                                    <input type="radio" id="authAlumnatEstranger0" name="authAlumnatEstranger" value={authAlumnatEstranger} checked={authAlumnatEstranger === "0" ? true : false} onChange={(t) => { handleChangeAlumnatEstranger("0") }} required />
                                    Aquest no és el cas que m'ocupa, atès que no provinc d'estudis estrangers de batxillerat o formació professional 
                                  </label>

                                  <br />

                                  <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authAlumnatEstranger}</span>

                                </p>


                              </div>
                            </div>

                                  <br/>



                            <div className="row">
                              <div className="col col-12 ">
                                <h4> Beca Erasmus+ {props.enguany}</h4>
                                <p></p>

                                <label>
                                  <input type="checkbox" id="erasmusConcedit" name="erasmusConcedit" value={erasmusConcedit} checked={erasmusConcedit === "1" ? true : false} onChange={(t) => { handleChangeErasmusConcedit(t.target.value) }} required />
                                  Se m'ha concedit beca Erasmus+ {props.enguany}
                                </label>

                              </div>
                            </div>

                            <br />
                            <br />



                                    { erasmusConcedit === "1" && (<>
                                    <div className="row">
                                      <div className="col col-12 ">
                                        <h4> ACCEPTACIÓ O RENÚNCIA beca Erasmus+ {props.enguany} Institut Jaume Mimó </h4>
                                        <p>

                                          L'alumnat a qui se li ha concedit una beca Erasmus+ per realitzar les seves pràctiques (en modalitat FCT) per al curs{props.enguany}-{props.anyVinent} a alguna empresa de la Unió Europea: <br/>

                                          <br />

                                          <label htmlFor="authErasmus1">
                                            <input type="radio" id="authErasmus1" name="authErasmus" value={authErasmus} checked={authErasmus === "1" ? true : false} onChange={(t) => { handleChangeErasmus("1") }} required />
                                            ACCEPTA la beca concedida (s’ha de firmar també la declaració jurada de bon estat de salut)
                                          </label>

                                          <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authErasmus}</span>

                                          <br />

                                          <label htmlFor="authErasmus0">
                                            <input type="radio" id="authErasmus0" name="authErasmus" value={authErasmus} checked={authErasmus === "0" ? true : false} onChange={(t) => { handleChangeErasmus("0") }} required />
                                            RENUNCIA a la beca concedida
                                          </label>

                                          <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authErasmus}</span>

                                          <br />
                                          <br />


                                          L’acceptació de la beca implica, així mateix, la de les clàusules que regeixen la convocatòria i la de la normativa acadèmica reguladora dels programes internacionals de mobilitat de l’Institut Jaume Mimó, així com de les condicions establertes pel soci i/o empresa del país de destinació.
                                          Amb l’acceptació de la beca em comprometo a:
                                          <ul>
                                            <li>Assistir a les sessions preparatòries prèvies a l’estada.</li>
                                            <li>Dur a terme la mobilitat.</li>
                                            <li>Mantenir una actitud professional, proactiva i constructiva.</li>
                                            <li>No desvincular-me del centre ni dels mòduls que estigui cursant durant l’estada.</li>
                                            <li>Fer l’enquesta EUSurvey al final de l’estada.</li>
                                            <li>Retornar la documentació pertinent omplerta i signada a la tornada.</li>
                                            <li>Enviar un vídeo resum de l’experiència, un escrit i 5 fotos a la tornada.</li>
                                          </ul>

                                          Un cop acceptada la beca mitjançant aquest document, el fet de renunciar-hi més endavant té les següents conseqüències:
                                          Si renuncia a la <b>beca abans de marxar</b>:
                                          <ul>
                                            <li>No tindrà la possibilitat de gaudir de futures beques.</li>
                                            <li>En cas de no haver fet les pràctiques, l'institut no li buscarà una altra empresa.</li>
                                          </ul>
                                          Si decideix tornar abans <b>un cop l'Erasmus ha començat</b>:
                                          <ul>
                                            <li>Haurà de tornar la beca en la seva totalitat (segons conveni de subvenció).</li>
                                            <li>No tindrà la possibilitat de gaudir de futures beques.</li>
                                            <li>En cas de no haver fet les pràctiques, l'institut no li buscarà una altra empresa.</li>
                                          </ul>

                                          D’altra banda, el centre es reserva el dret de retirar la beca Erasmus+ si l’equip docent i/o l’equip de mobilitat ho creuen oportú per motius d’actitud, inestabilitat, etc en qualsevol moment.

                                </p>


                              </div>
                            </div>

                                  <br/>

                                    </>)}



                              <div className="row">
                              <div className="col col-12 ">
                                <h4>
                                Carta de compromís de pràctiques en empresa (dual general i intensiva)
                                </h4>
                                <p>

                                    <h5>Declaració de l'alumne:</h5>

                                      <ul>
                                        <li>En el cas que renunciï a l’empresa que m’ofereix el centre, m’hauré de buscar jo l’empresa per fer les pràctiques.</li>
                                        <li>En el cas que abandoni, una vegada ja començada la formació pràctica, seré jo mateix qui em buscaré l’empresa per fer les pràctiques.</li>
                                        <li>Que si sóc alumne/a Erasmus, i dual intensiva; em comprometo a realitzar 713 hores (mínim) a l’empresa on faig dual intensiva.</li>
                                        <li>Em comprometo a complir l’horari, tant en l’empresa com en l’institut (i no perdre la convocatòria ordinària), en cas contrari, des del centre es finalitzarà anticipadament l’acord, i hauré de realitzar les pràctiques el següent curs.</li>
                                        <li>Que si treballo cada matí, hauré de posposar les pràctiques a un tercer curs (en el cas que no pugui demanar exempció total).</li>
                                        <li>Què si per la meva situació personal demano semipresencialitat al centre, hauré de posposar les pràctiques a un tercer curs.</li>
                                        <li>Em comprometo durant el primer trimestre a obtenir el NASS (núm. d’afiliació de la Seguretat Social), i si sóc major d’edat a tenir SIGNATURA DIGITAL.</li>
                                        <li>He d’emplenar cada dia les activitats a la plataforma SBID, i al finalitzar cada mes, fer la valoració corresponent. Al finalitzar les pràctiques, emplenar el qüestionari final.</li>
                                        <li>En el cas d’absentar-me de l’empresa, o tenir qualsevol problema, hauré d’informar a l’empresa i al centre (al tutor/a SBID).</li>
                                        <li>Emplenaré el formulari de dades per poder començar les pràctiques, que se m’enviarà durant el mes de gener, dins del termini marcat.</li>
                                        <li>En fer la matrícula, m’han informat dels trets específics d’aquest cicle formatiu i dels requisits addicionals que haig de tenir en compte com a alumne/a que s’hi matricula.</li>
                                        <li>L’incompliment d’algun dels punts anteriors, comportarà la sanció especificada en la guia de pràctiques i en la Normativa de centre (NOFC).</li>
                                    </ul>

                                  <br />

                                  <label> 
                                      <input type="checkbox" id="authPractiquesEmpresa" name="authPractiquesEmpresa" value={authPractiquesEmpresa} checked={authPractiquesEmpresa === "1" ? true : false } onChange={ (t) => { handleChangePractiquesEmpresa(t.target.value) } } required/>
                                    Accepto i em comprometo a seguir els acords establerts anteriorment, assumint totes les responsabilitats que se’n deriven.
                                  </label>

                                  <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authPractiquesEmpresa}</span>

                                </p>


                              </div>
                            </div>

                                  <br/>

                                </>)}




                              <div className="row">
                              <div className="col col-12 ">
                                <h4>
                                  Autorització per a l’ús de serveis i recursos digitals a Internet per treballar a l'aula
                                </h4>
                                <p>

                                    Per al treball acadèmic de les diferents matèries els alumnes han d'utilitzar diverses eines informàtiques i, en especial, aquelles relacionades amb la transmissió d’informació a traves d'Internet: correu electrònic, creació de blogs opàgines web, etc.<br/>
                                  <br/>

                                    Per tal de treballar aquests continguts el centre crearà un compte personal de Google Apps per cada membre de l'alumnat.<br/>
                                  <br/>

                                    El compte tindrà el format usuari@insjaumemimo.cat i permetrà fer diferents tasques relacionades amb el currículum. Aquest compte serà d'us exclusivament acadèmic, de manera que l'alumnat no haurien d'utilitzar-lo dins del seu àmbit personal.<br/>
                                  <br/>

                                    En algun cas també poden tenir accés a cursos d'alguna matèria en la plataforma Moodle del centre. D'altra banda, si en alguna matèria s’utilitzés llibres digitals, caldria que la corresponent editorial creessin els comptes a instància del centre.<br/>
                                  <br/>
                                    La normativa del Departament d'Educació marca que per als menors de 14 anys es necessari el permís per escrit dels pares o tutors, mentre que si l'alumne es major de 14 anys, només cal informar els pares o tutors<br/>
                                  <br/>

                                  <input type="checkbox" id="authRecursosDigitals" name="authRecursosDigitals" value={authRecursosDigitals} checked={authRecursosDigitals === "1" ? true : false } onChange={ (t) => { handleChangeRecursosDigitals(t.target.value) } } required/>
                                  <label htmlFor="authRecursosDigitals"> 

                                   { props.dadesPersonals.edat < 14 ? 
                                      "Autoritzo que el centre gestioni la creació de l’usuari i contrasenya associats als següents recursos i serveis d’Internet:"
                                      :
                                      "Declaro que estic assabentat/ada que el centre gestionarà la creació de l’usuari i contrasenya associats als següents cursos i serveis d’Internet:"
                                   }

                                       <br/> Google Apps per a Educació, plataforma Moodle i si s’escau, llibres de text digitals per al treball acadèmic amb finalitat pedagògiques. <br/>

                                  </label>
                                  <span id="auhtRecursosDigitals_ERROR" className="a-Form-error">{errors.authRecursosDigitals}</span>
                                </p>

                                <p>
                                La gestió d'aquests identificadors i la responsabilitat de l’ús que se'n faci en l'àmbit escolar correspon al
                                centre educatiu. Aquest no es fa responsable de l’ús indegut del recurs i dels seus continguts per part dels
                                usuaris. L'usuari serà únic responsable de les infraccions en què pugui incórrer o dels perjudicis que pugui
                                causar per un us inadequat dels seus serveis o dels seus continguts.
                                </p>

                              </div>
                            </div>


                                <br/>




                                      <br/>

                                <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                      Declaració responsable de veracitat de les dades aportades 
                                    </h4>
                                    <p>
                                      <input type="checkbox" id="authResponsable" name="authResponsable" value={authResponsable} checked={authResponsable === "1" ? true : false } onChange={ (t) => { handleChangeResponsable(t.target.value) } } required/>
                                      <label htmlFor="authResponsable">Declaro que totes les dades aportades en aquest procediment són certes i la possibilitat d'acreditar documentalment totes les dades esmentades anteriorment, en cas que se m'exigeixin.</label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authResponsable}</span>
                                    </p>

                                  </div>
                                </div>


                  {/* Avís per als que han de fer 18 anys durant el curs */}
                  {props.dadesPersonals.edat === 17 && (
                    <>
                      <br />
                      <div className="row">
                        <div className="col col-12 ">
                          <h4>
                          Consentiment menors
                          </h4>
                          <p>
                          Les autoritzacions i el consentiment de seguiment tutorial per part de la família, implícit en el cas dels menors d'edat, tenen validesa durant tot el curs encara que l'alumnat compleixi 18 anys durant el mateix. <br/>
                          L'alumnat pot exercir el seu dret de majoria d'edat signant noves autoritzacions a través de la tutoria.
                          </p>

                        </div>
                      </div>

                      <br />
                    </>)}

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>












                  <div className="container">
                            <div className="row">
                              <div className="col col-12" align="center">
                                <button onClick={validaAutoritzacions} className="button">SEGÜENT</button>
                              </div>
                            </div>
                          </div>

                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
